import * as Yup from 'yup';

export const model = {
  category: {
    name: 'category',
    inputType: 'input',
    placeholder: 'Choose a category',
  },
  message: {
    name: 'message',
    inputType: 'textarea',
    placeholder: 'Write your question...',
  },
  screenshot: {
    name: 'screenshot',
    type: 'file',
    placeholder: 'Attach image (optional)',
  },
};

export const validationSchema = Yup.object().shape({
  [model.message.name]: Yup.string().required('Required'),
  [model.category.name]: Yup.string().required('Required'),
});

export const initialValues = (data: any) => ({
  [model.message.name]: data?.message ?? '',
  [model.category.name]: data?.category ?? '',
});
